import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=338f38cd&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=tsx&"
export * from "./Dashboard.vue?vue&type=script&lang=tsx&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=338f38cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f38cd",
  null
  
)

export default component.exports